import React from "react";
import { ellipsis } from "polished";
import { Box } from "rebass";
import styled from "styled-components";

import Text from "./Text";

const Wrapper = styled(Box)`
  display: inline-block;
  max-width: 128px;
  /* background-color: ${(props) => props.theme.colors.grey[1]}; */
  background-color: ${(props) =>
    props.backgroundColor
      ? props.theme.colors[props.backgroundColor]
      : props.theme.colors.grey[1]};
`;

Wrapper.defaultProps = {
  px: 2,
};

const Content = styled(Text)`
  font-size: 11px;
  font-weight: 600;
  color: ${(props) => (props.color ? props.color : props.theme.colors.grey[0])};
  ${ellipsis()};
  line-height: 2;

  &::selection {
    color: ${(props) => props.theme.colors.grey[2]};
    background-color: ${(props) => props.theme.colors.violet};
  }
`;

const Tag = (props) => (
  <Wrapper backgroundColor={props.backgroundColor}>
    <Content children={props.children} color={props.color} />
  </Wrapper>
);

Tag.defaultProps = {
  children: "Lorem ipsum dolor amet",
};

export default Tag;



// WEBPACK FOOTER //
// ./src/components/Tag.js